import { GzDialogWebComponent } from '../../ui/gzDialog';
import { ButtonColors, ButtonTypes } from '../../ui/gzButton/types';
import { GzButtonWebComponent } from '../../ui/gzButton';

export const showCreateAccountDialog = (
  translations,
  companyName: string | undefined,
  callback: () => Promise<void>
) => {
  const title = translations.createAccount;
  const body = translations.customerCreateAccountText(companyName);

  const createButton = `<gz-button type="${ButtonTypes.FULL}" color="${ButtonColors.PRIMARY}" id="confirm">
      ${translations.createAccount}
    </gz-button>`;

  const cancelButton = `<gz-button type="${ButtonTypes.OUTLINE}" color="${ButtonColors.SECONDARY}" id="cancel">
      ${translations.cancel}
    </gz-button>`;

  const footer = createButton + cancelButton;

  let dialog: GzDialogWebComponent | null = null;

  const confirm = async () => {
    const confirmBtn = dialog?.footerContent?.querySelector('#confirm') as GzButtonWebComponent;
    confirmBtn.setLoadingState(true);

    await callback();

    dialog?.close();
  };

  dialog = GzDialogWebComponent.computeCustomDialog(body, footer, title, null, confirm, null, false);
};
